import { Component, computed, input } from "@angular/core";
import { OfEtat } from "../../enums/etat-of.enum";
import { MatIcon } from "@angular/material/icon";
import { OfEtatService } from "./of-etat.service";

@Component({
  selector: "vl-icon-of-etat",
  standalone: true,
  imports: [MatIcon],
  templateUrl: "./icon-of-etat.component.html",
  styleUrl: "./icon-of-etat.component.scss",
})
export class IconOfEtatComponent {
  etat = input<OfEtat>();
  ofEtat = OfEtat;

  etatColor = computed(() => {
    return OfEtatService.getOfEtatColor(this.etat());
  });
}
